import { createTheme } from '@mui/material/styles';
import { buildTheme } from './baseTheme';

const baseTheme = buildTheme('light'); // hardcoded for now, but can be changed to 'dark' if needed

// TODO: MIGRATE BELOW Theme creation logic TO baseTheme
// This is the legacy theme definition that was used before the new theme system
// was introduced. It is kept here for reference and to ensure backward compatibility.
let theme = createTheme(baseTheme, {
    // Theme customization goes here as usual, including tonalOffset and/or
    // contrastThreshold as the augmentColor() function relies on these
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: 'var(--color-dark-grey)',
                    backgroundColor: 'var(--color-white)',
                    boxShadow: '1px 1px 5px #5d6d7e80',
                    border: '1px solid #5d6d7e80',
                },
            },
        },
        MuiSvgIcon: {
            variants: [
                {
                    props: { size: 'extraSmall' },
                    style: {
                        fontSize: 16,
                    },
                },
            ],
        },
    },
    MuiTextField: {
        defaultProps: {
            InputLabelProps: { shrink: true },
        },
    },
});

theme = createTheme(theme, {
    typography: {
        landingPageTitle: {
            fontSize: 14,
            fontWeight: 700,
        },
        landingPageSubTitle: {
            fontSize: 12,
            color: '#828282',
        },
        subtitle1: {
            fontSize: 14,
            color: '#828282',
        },
        formLabel: {
            fontSize: 16,
            color: '#828282',
            fontWeight: 500,
        },
        helpText: {
            fontSize: 14,
            color: '#1976d2',
        },
        tooltipBold: {
            fontSize: 12,
            fontWeight: 700,
        },
        caption11: {
            fontSize: '0.6875rem', // 11px
            fontWeight: 400,
            lineHeight: 1.5,
        },
    },
    // Custom colors created with augmentColor go here
    palette: {
        gray3: theme.palette.augmentColor({
            color: {
                main: '#828282',
            },
            name: 'gray3',
        }),
        border: {
            primary: theme.palette.augmentColor({
                color: {
                    main: '#212121',
                },
                name: 'primary',
            }),
            secondary: theme.palette.augmentColor({
                color: {
                    main: '#757575',
                },
                name: 'secondary',
            }),
        },

        buttonText: {
            light: theme.palette.augmentColor({
                color: {
                    main: '#fafafa',
                },
                name: 'light',
            }),
        },
    },
});

export const DEFAULT_THEME = theme;
